import { merge, cloneDeep } from "lodash";
import { config } from "src/config/config";
import { USER_ASSET_ACTIONS } from "src/actions/user_asset_actions";
import {
  AjaxStatus,
  APICallStatus,
  TrmFlowTxStatus,
} from "src/service/api_types";
import { checkApiStatus } from "src/service/utils";
import { data } from "jquery";

const defaultState = {
  createdAssets: {
    pageNumber: 0,
    status: { status: APICallStatus.INIT },
    data: null,
  },
  updateAsset: {
    status: { status: APICallStatus.INIT },
    transaction: null,
  },
  delistAsset: {
    status: { status: APICallStatus.INIT },
    transaction: null,
  },
  listAsset: {
    status: { status: APICallStatus.INIT },
    transaction: null,
  },
  copyAsset: {
    status: { status: APICallStatus.INIT },
    transaction: null,
  },
  distributeAsset: {
    status: { status: APICallStatus.INIT },
    transaction: null,
  },
  selectedSaleAssets: {
    data: [],
  },
  flowTxStatus: {
    status: { status: APICallStatus.INIT },
    data: { status: TrmFlowTxStatus.UNKNOWN },
  },
};

export const userAssetsReducer = (state = defaultState, action) => {
  switch (action.type) {
    case USER_ASSET_ACTIONS.GET_ASSETS_CREATED_BY_USER: {
      if (config.APP_DEBUG) {
        console.log(
          "USER_ASSET_ACTIONS.GET_ASSETS_CREATED_BY_USER: ",
          action.data
        );
      }

      let assets = action.data.response;
      return {
        ...state,
        createdAssets: {
          pageNumber:
            assets && assets.length
              ? action.data.pageNumber
              : state.createdAssets.pageNumber,
          data: assets,
          status: checkApiStatus(action.data.ajaxStat, null),
        },
      };
    }
    case USER_ASSET_ACTIONS.INIT_ASSETS_CREATED_BY_USER: {
      if (config.APP_DEBUG) {
        console.log(
          "USER_ASSET_ACTIONS.INIT_ASSETS_CREATED_BY_USER: ",
          action.data
        );
      }

      let newState = {
        createdAssets: {
          status: { status: APICallStatus.INIT },
          data: [],
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.START_ASSETS_CREATED_BY_USER: {
      if (config.APP_DEBUG) {
        console.log(
          "USER_ASSET_ACTIONS.START_ASSETS_CREATED_BY_USER: ",
          action.data
        );
      }

      let newState = {
        createdAssets: {
          status: { status: APICallStatus.IN_PROGRESS },
          data: [],
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.UPDATE_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.UPDATE_ASSET: ", action.data);
      }

      let newState = {
        updateAsset: {
          status: checkApiStatus(action.data.ajaxStat, null),
          transaction: action.data.response,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.INIT_UPDATE_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.INIT_UPDATE_ASSET: ", action.data);
      }

      let newState = {
        updateAsset: {
          status: { status: APICallStatus.INIT },
          transaction: null,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.START_UPDATE_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.START_UPDATE_ASSET: ", action.data);
      }

      let newState = {
        updateAsset: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.DELIST_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.DELIST_ASSET: ", action.data);
      }

      let newState = {
        delistAsset: {
          status: checkApiStatus(action.data.ajaxStat, null),
          transaction: action.data.response,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.INIT_DELIST_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.INIT_DELIST_ASSET: ", action.data);
      }

      let newState = {
        delistAsset: {
          status: { status: APICallStatus.INIT },
          transaction: null,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.START_DELIST_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.START_DELIST_ASSET: ", action.data);
      }

      let newState = {
        delistAsset: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.LIST_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.LIST_ASSET: ", action.data);
      }

      let newState = {
        listAsset: {
          status: checkApiStatus(action.data.ajaxStat, null),
          transaction: action.data.response,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.INIT_LIST_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.INIT_LIST_ASSET: ", action.data);
      }

      let newState = {
        listAsset: {
          status: { status: APICallStatus.INIT },
          transaction: null,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.START_LIST_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.START_LIST_ASSET: ", action.data);
      }

      let newState = {
        listAsset: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.COPY_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.COPY_ASSET: ", action.data);
      }

      let newState = {
        copyAsset: {
          status: checkApiStatus(action.data.ajaxStat, null),
          transaction: action.data.response,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.DISTRIBUTE_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.DISTRIBUTE_ASSET: ", action.data);
      }

      let newState = {
        distributeAsset: {
          status: checkApiStatus(action.data.ajaxStat, null),
          transaction: action.data.response,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.INIT_DISTRIBUTE_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.INIT_DISTRIBUTE_ASSET: ", action.data);
      }

      let newState = {
        distributeAsset: {
          status: { status: APICallStatus.INIT },
          transaction: null,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.START_DISTRIBUTE_ASSET: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.START_DISTRIBUTE_ASSET: ", action.data);
      }

      let newState = {
        distributeAsset: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.SALE_ASSETS_SELECTED: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.SALE_ASSETS_SELECTED: ", action.data);
      }

      return {
        ...state,
        selectedSaleAssets: action.data,
      };
    }
    case USER_ASSET_ACTIONS.INIT_GET_FLOW_TX_STATUS: {
      if (config.APP_DEBUG) {
        console.log(
          "USER_ASSET_ACTIONS.INIT_GET_FLOW_TX_STATUS: ",
          action.data
        );
      }

      let reset_status =
        action.data !== undefined ? action.data.reset_status : false;
      const prevStatData = state.flowTxStatus.data;
      let statData = prevStatData ? cloneDeep(prevStatData) : undefined;
      if (statData) {
        if (
          reset_status ||
          statData.status === TrmFlowTxStatus.FAILED ||
          statData.status === TrmFlowTxStatus.DONE
        ) {
          statData.status = TrmFlowTxStatus.UNKNOWN;
        }
      }

      let newState = {
        flowTxStatus: {
          status: { status: APICallStatus.INIT },
          data: statData,
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.START_GET_FLOW_TX_STATUS: {
      if (config.APP_DEBUG) {
        console.log(
          "USER_ASSET_ACTIONS.START_GET_FLOW_TX_STATUS: ",
          action.data
        );
      }

      let newState = {
        flowTxStatus: {
          status: { status: APICallStatus.IN_PROGRESS },
        },
      };
      return merge({}, state, newState);
    }
    case USER_ASSET_ACTIONS.GET_FLOW_TX_STATUS: {
      if (config.APP_DEBUG) {
        console.log("USER_ASSET_ACTIONS.GET_FLOW_TX_STATUS: ", action.data);
      }

      let txStat = action.data.response;
      if (action.data.ajaxStat === AjaxStatus.FAILED) {
        txStat.status = TrmFlowTxStatus.FAILED;
      }

      let newState = {
        flowTxStatus: {
          status: checkApiStatus(action.data.ajaxStat, null),
          data: txStat,
        },
      };
      return merge({}, state, newState);
    }
    default:
      return state;
  }
};
